import {
  IOrganizationData,
  ORGANIZATION_STATUS,
} from "@home-health-notify/domain";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { alpha } from "@mui/material";
import { stringAvatar, useTranslation } from "hhn-commons";
import theme from "../theme";
import { AVATAR_SIZE } from "../utils/AvatarUtils";
import {
  CustomAvatar,
  OrgTile,
  PendingMarker,
  StyledBadge,
} from "./Sidebar.style";

type OrganizationStyledBadgeProps = {
  org: IOrganizationData;
  isActive: boolean;
  unreadCount?: number;
};

const OrganizationStyledBadge = ({
  org,
  isActive,
  unreadCount,
}: OrganizationStyledBadgeProps) => {
  const { t } = useTranslation();
  const badgeCount = unreadCount ?? org.unreadAlertCount;
  const isPending = org.organizationStatus === ORGANIZATION_STATUS.PENDING;
  const expiringSoonLabel = t("expiringSoon", { ns: "organization" });
  return (
    <StyledBadge
      overlap="circular"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      badgeContent={badgeCount}
      invisible={!badgeCount}
      color="error"
    >
      <OrgTile>
        <CustomAvatar
          alt={org.organizationName}
          sx={{
            height: AVATAR_SIZE.SMALL,
            width: AVATAR_SIZE.SMALL,
            bgcolor: isActive
              ? theme.palette.common.white
              : alpha(theme.palette.primary.main, 0.9),
            color: isActive
              ? theme.palette.primary.main
              : alpha(theme.palette.common.white, 0.9),
          }}
          variant="square"
        >
          {stringAvatar(org.organizationName, false, 3)}
        </CustomAvatar>
        {isPending && (
          <PendingMarker
            role="img"
            aria-label={expiringSoonLabel}
            data-testid="org-pending-marker"
          >
            <AccessTimeFilledIcon
              sx={{ fontSize: 14, color: theme.palette.warning.main }}
            />
          </PendingMarker>
        )}
      </OrgTile>
    </StyledBadge>
  );
};

export default OrganizationStyledBadge;
